import type { FetchCustomImageRowProps, JaneDM } from '@iheartjane/dm-sdk';
import { useCallback } from 'react';

import type { AlgoliaProduct } from '@jane/search/types';
import type { MenuCategoryPath } from '@jane/shared/types';

import type {
  UseFetchPlacement,
  UseFetchPlacementProps,
} from './useFetchPlacement';
import { useFetchPlacement } from './useFetchPlacement';

interface UseCustomImageRowInnerProps {
  pageCategory?: MenuCategoryPath;
}

type UseCustomImageRowProps = Omit<
  UseFetchPlacementProps<FetchCustomImageRowProps>,
  'dependencies'
> &
  UseCustomImageRowInnerProps;

export const useCustomImageRow = <ProductShape extends object = AlgoliaProduct>(
  props: UseCustomImageRowProps
): UseFetchPlacement<ProductShape> => {
  const { pageCategory, searchFilter, enabled, storeId, searchAttributes } =
    props;

  const dependencies = [searchFilter, pageCategory, storeId];

  const fetchPlacement = useCallback(async (sdk: JaneDM) => {
    return await sdk.fetchCustomImageRow<ProductShape>({
      searchAttributes,
      searchFilter,
      storeId: Number(storeId),
    });
  }, dependencies);

  return useFetchPlacement<ProductShape>(
    { dependencies, enabled },
    fetchPlacement
  );
};
